export const mitigationTypes = {
  THREAT: { key: 'THREAT', title: 'Threat' },
  BARRIER: { key: 'BARRIER', title: 'Barrier/Control' },
  CONSEQUENCE: { key: 'CONSEQUENCE', title: 'Consequence' },
  POLICY: { key: 'POLICY', title: 'Policy' },
};

export const riskStatus = {
  COMPLETE: {
    title: 'Complete',
    key: 'COMPLETE',
    color: 'green',
  },
  IN_PROGRESS: {
    title: 'In Progress',
    key: 'IN_PROGRESS',
    color: 'yellow',
  },
  NEW: {
    title: 'New',
    key: 'NEW',
    color: 'blue',
  },
  ARCHIVED: {
    title: 'Archived',
    key: 'ARCHIVED',
    color: 'red',
  },
  ACTION: {
    title: 'Action Rqd',
    key: 'ACTION',
    color: 'yellow',
  },
  OVERDUE: {
    title: 'Overdue',
    key: 'OVERDUE',
    color: 'red',
  },
};
export const registryStatus = {
  REVIEWED: {
    title: 'Reviewed',
    key: 'REVIEWED',
    color: 'green',
  },
  OVERDUE: {
    title: 'Overdue',
    key: 'OVERDUE',
    color: 'red',
  },
  INCOMPLETE: {
    title: 'Incomplete',
    key: 'INCOMPLETE',
    color: 'orange',
  },
  EXPIRING: { title: 'Expiring', key: 'EXPIRING', color: 'orange' },
  NEW: {
    title: 'New',
    key: 'NEW',
    color: 'blue',
  },
};

export const mitigationLookup = {
  THREAT: 'threats',
  BARRIER: 'barriers',
  CONSEQUENCE: 'consequences',
  POLICY: 'policies',
};

export const riskLevelFilter = (level) => {
  let value = [];
  switch (level) {
    case 'LOW':
      value = ['1', '6'];
      break;
    case 'MEDIUM':
      value = ['7', '12'];
      break;
    case 'HIGH':
      value = ['13', '25'];
      break;
    default:
      return value;
  }
  return { field: 'riskScore', operator: 'between', value };
};
export const riskTypes = {
  PEOPLE: { label: 'People', value: 'PEOPLE' },
  ASSETS: { label: 'Assets', value: 'ASSETS' },
  REPUTATION: { label: 'Reputation', value: 'REPUTATION' },
  ENVIRONMENTAL: { label: 'Environmental', value: 'ENVIRONMENTAL' },
  OPERATIONAL: { label: 'Operational', value: 'OPERATIONAL' },
  COMPLAINCE: { label: 'Compliance/Regulatory', value: 'COMPLIANCE' },
  FINANCIAL: { label: 'Financial', value: 'FINANCIAL' },
  SECURITY: { label: 'Security', value: 'SECURITY' },
  OTHER: { label: 'Other/Misc', value: 'OTHER' },
};

export function convertRegistryImport(row) {
  const splitKeys = ['Threats', 'Consequences', 'Barriers'];
  let newRow = {};

  Object.entries(row).forEach(([key, value]) => {
    if (splitKeys.includes(key)) {
      newRow[key] =
        typeof value === 'string'
          ? value
              .split(',')
              .map((s) => s.trim())
              .filter(Boolean)
          : value;
    } else {
      newRow[key] = value;
    }
  });

  return newRow;
}
